export default __webpack_public_path__ + "static/media/pencil.d5fb7f25.svg";